<!-- 会员消费记录 -->

<template>
    <div class="address">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1"></div>
                <div class="searchBox flex flex-align-center">
                   <div class="searchCon clearfix">
                        <div class="left searchBtn">
                            <button type="button" @click="showUpBox(null)"><i class="el-icon-plus"></i>添加规格组</button>
                        </div>
                    </div>
                </div>
                <div class="HSpace2"></div>
                <div class="tableBox">
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr>
                                <th style="width:20%;text-align:left;padding-left:10%;">规格组名</th>
                                <th style="width:40%;text-align:left;padding-left:10%;">所含规格</th>
                                <th style="width:20%;text-align:left;padding-left:10%;">默认规格</th>
                                <th style="width:20%;text-align:right;padding-right:10%;">操作</th>
                            </tr>
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:addressData.length>10}">
                                    <tr v-for="item in addressData">
                                        <td  style="width:20%;text-align:left;padding-left:10%;"><span v-text="item.name"></span></td>
                                        <td  style="width:40%;text-align:left;padding-left:10%;"><span>{{(item.specs && Array.isArray(item.specs))?item.specs.join("、"):""}}</span></td>
                                        <td  style="width:20%;text-align:left;padding-left:10%;"><span>{{item.defaultSpec}}</span></td>
                                        <td   style="width:20%;text-align:right;padding-right:10%;">
                                            <span title="修改" style="margin:0 2%;cursor:pointer" v-if="item.id" @click="showUpBox(item)"><i class="iconfont icon-bianji"></i></span>
                                            <span title="删除" style="cursor:pointer;" @click="delAddr(item)" v-if="item.id"><i class="iconfont icon-icon1460188478041"></i></span>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            :title="'添加/编辑规格组'"
            :visible.sync="addAddrBtn"
            size="tiny">
            <div>
                <div class="msgBox clearfix">
                    <div class="left msgItem clearfix">
                        <span class="left itemName"><i>*</i>规格组名称</span>
                        <input type="text" class="left itemInput" v-model="name" placeholder="请输入规格组名称" >
                    </div>
                    <div class="left msgItem clearfix">
                        <span class="left itemName"><i>*</i>添加规格</span>
                        <!-- <input type="text" @keyup.enter="modifySpec('add')" class="left itemInput" v-model="autoSpec" placeholder="请输入规格..."> -->
                        <input style="width:57.89%" type="text" class="left itemInput" v-model="autoSpec" placeholder="请输入规格...">
                        <el-button type="primary" @click="modifySpec('add')" size="small" style="margin-left:20px;">添加</el-button>
                        <!-- <el-button type="text" style="padding-left:25%">自定义输入，输入完成之后按回车键</el-button> -->
                    </div>
                    <div class="left msgItem clearfix" v-if="specs && Array.isArray(specs) && specs.length">
                        <span class="left itemName">已添加规格</span>
                        <el-tag
                        style="margin:5px"
                        closable
                        v-for="(tag,index) in specs"
                        @close="modifySpec('del',index)"
                        :key="`_${index}`"
                        >
                        {{tag}}
                        </el-tag>
                    </div>
                    <div class="left msgItem clearfix">
                        <span class="left itemName"><i>*</i>默认规格</span>
                        <el-select v-model="defaultSpec" placeholder="请选择">
                            <el-option
                            v-for="item in specs"
                            :key="item"
                            :label="item"
                            :value="item">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <button type="button" @click="addAddrBtn=false" class="cancel">取消</button>
                <button type="button" @click="addAddrFn" class="save">保存</button>
            </span>
        </el-dialog>
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    import {BASE_URL} from "../../../urlConfig";
    export default{
        props: ['pageSize','curStoreId'],
    	data () {
    		return {
                specs:[],
                defaultSpec:"",
                autoSpec:"",
                dialogVisible: false,
                addAddrBtn:false,//添加地址按钮
                addressData:[],//地址列表
                addr:'',//收货地址
                name:'',//姓名
                phone:"",
                userName:"",//用户手机号
                id:"",
    		}
    	},

        methods: {
            modifySpec(type,index){
                let specs = JSON.parse(JSON.stringify(this.specs));
                if(type == "add"){
                    if(!String(this.autoSpec).trim()){
                        this.$message({
                            message: '请输入规格名称',
                            customClass: 'error'
                        })
                        return;
                    }
                    specs.push(this.autoSpec);
                    this.autoSpec = '';
                }else if(type=="del"){
                    specs.splice(index,1);
                }
                this.specs = specs;
            },
            // 
            //删除地址
            delAddr(item){
                this.$confirm('此操作将删除该规格组, 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                    this.$http({
                        url:"spec/delete",
                        method:"POST",
                        data:{
                            id:item.id
                        }
                    }).then((res)=>{
                        this.getSpecs();
                    })
                }).catch(() => {});
            },
            //新建或更新地址
            addAddrFn(id){
                if(!this.name){
                    this.$message({
                        message: '请填写规格组名称',
                        customClass: 'error'
                    })
                    return;
                }
                if(!this.specs || !Array.isArray(this.specs) || !this.specs.length){
                    this.$message({
                        message: '请添加规格',
                        customClass: 'error'
                    })
                    return;
                }
                if(!this.defaultSpec){
                    this.$message({
                        message: '请选择默认规格',
                        customClass: 'error'
                    })
                    return;
                }

                this.$http({
                    url:"edit/spec",
                    method:"POST",
                    data:{
                        id:this.id?this.id:0,
                        name:this.name,
                        storeId:this.curStoreId,
                        specs:this.specs,
                        defaultSpec:this.defaultSpec,
                    }
                }).then((res)=>{
                    this.getSpecs();
                    this.addAddrBtn = false;
                    this.name = '';
                    this.id = '';
                    this.defaultSpec = '';
                    this.specs = [];
                    this.$message({
                        message: '操作成功！',
                        customClass: 'success'
                    })
                })
            },
            showUpBox(item){
                if(item){
                    this.id = item.id;
                    this.name = item.name;
                    this.specs = item.specs;
                    this.defaultSpec = item.defaultSpec ? item.defaultSpec : "";
                }else{
                    this.id = "";
                    this.name = "";
                    this.specs = [];
                    this.defaultSpec = "";
                }
                this.addAddrBtn = true;
            },
            getSpecs(){
                this.$http({
                    url:"spec/list",
                    method:"POST",
                    data:{
                        storeId:this.curStoreId,
                    }
                }).then((res)=>{
                    this.addressData = res.data;
                    if( this.addressData.length < this.pageSize ){
                        for(let i = 0, len = this.pageSize - this.addressData.length; i < len; i++){
                            this.addressData.push({})
                        }
                    }
                })
            }
        },
        created: function () {
            this.userName = localStorage.getItem("username");
            for (let i = 0; i < this.pageSize; i++) {
                this.addressData.push({})
            }
        },
        activated: function () {
           this.getSpecs();
        }
    }
</script>
<style lang="scss">
    @import '../../../../static/css/common.scss';
    @import '../../tableTemplate/tableTem.scss';
    @import '../../tableTemplate/el-dialog.scss';
	@import "./spec.scss";
</style>



// WEBPACK FOOTER //
// spec.vue?a0a5b3dc